import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var HeadphonesOutline = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("g", {
    "data-name": "Layer 2",
    key: "k0"
  }, React.createElement("path", {
    d: "M12 2A10.2 10.2 0 002 12.37V17a4 4 0 104-4 3.91 3.91 0 00-2 .56v-1.19A8.2 8.2 0 0112 4a8.2 8.2 0 018 8.37v1.19a3.91 3.91 0 00-2-.56 4 4 0 104 4v-4.63A10.2 10.2 0 0012 2zM6 15a2 2 0 11-2 2 2 2 0 012-2zm12 4a2 2 0 112-2 2 2 0 01-2 2z",
    "data-name": "headphones"
  })));
});
HeadphonesOutline.displayName = 'HeadphonesOutline';
export var HeadphonesOutlineDimensions = {
  height: 20,
  width: 20
};